module.exports = __webpack_public_path__ + "img/20.bce2f95e.png";